import type { Topic } from "@/mocks/topics";
import BookmarkButton from "@/components/feature/BookmarkButton";

interface TopicCardProps {
  topic: Topic;
  index?: number;
  compact?: boolean;
}

export default function TopicCard({ topic, compact = false }: TopicCardProps) {
  return (
    <article className="group flex flex-col h-full rounded-lg border border-background-200 bg-background-50 overflow-hidden transition-colors hover:border-primary-300">
      <div className={`relative w-full overflow-hidden ${compact ? "h-40" : "h-48"}`}>
        <img
          src={topic.cover}
          alt={`${topic.title} - 5看料网话题配图`}
          title={`${topic.title} - 5看料网`}
          className="w-full h-full object-cover object-top"
        />
        <span className="absolute top-3 left-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-background-50/90 text-[11px] font-medium text-primary-700">
          <i className="ri-price-tag-3-line text-xs"></i>
          {topic.category}
        </span>
        <span className="absolute top-3 right-3">
          <BookmarkButton id={topic.id} tone="icon" />
        </span>
      </div>

      <div className="flex flex-col flex-1 p-4 md:p-5">
        <h3 className="font-heading text-base md:text-lg font-semibold leading-7 text-foreground-950 line-clamp-2">
          {topic.title}
        </h3>
        <p className="mt-2 text-sm leading-6 text-foreground-600 line-clamp-2">{topic.summary}</p>

        <div className="mt-3 flex flex-wrap gap-2">
          {topic.tags.map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-[11px]"
            >
              {tag}
            </span>
          ))}
        </div>

        <div className="mt-auto pt-4 flex items-center justify-between gap-2 text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-fire-line text-primary-500"></i>
            {topic.heat.toLocaleString()}
          </span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-bookmark-3-line"></i>
            {topic.saved.toLocaleString()}
          </span>
          <span className="hidden sm:inline-flex items-center gap-1.5">
            <i className="ri-calendar-line"></i>
            {topic.date}
          </span>
        </div>
      </div>
    </article>
  );
}